const newlineRegex = /\r?\n|\\?\\r?\\?\\n/;
function splitStringByLine(string) {
  return string.split(newlineRegex);
}
export default splitStringByLine;